<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="m-3">
                <b-col>
                    <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">
                        FINAL ACKNOWLEDGEMENT &amp; ELECTRONIC ACCEPTANCE
                    </h4>
                    <div style="margin-bottom: 15px; font-size: 14px;">
                        <p><strong>FINAL ACKNOWLEDGEMENT</strong></p>
                        <p>
                            I acknowledge and agree that the terms and conditions of this Enrollment Agreement
                            and the Student Handbook are not subject to amendment or modification by spoken
                            agreement. I further acknowledge and agree that no spoken statements have been
                            made to me that are contrary to what is contained in this Enrollment Agreement or the
                            Student Handbook. My signature below certifies that I have read, understand, and
                            agree to comply with all terms, conditions, policies, rules, and procedures contained in
                            this Enrollment Agreement and the Student Handbook, including any updates or
                            revisions made in accordance with institutional policy. I understand that the Student
                            Handbook is included in this Enrollment Agreement and forms an important part of this
                            contract. This Enrollment Agreement is legally binding when signed by me and accepted
                            by Bay Atlantic University, Mentora College Continuing Education Program.
                        </p>
                    </div>
                    <div class="mb-3" style="font-size: 14px;">
                        <p><strong>CONTRACT ACCEPTANCE</strong></p>
                        <p>
                            I, the undersigned, have read and understood this agreement and agree that it, together
                            with the Student Handbook, supersedes all prior or existing verbal or written
                            agreements. This agreement may not be modified/changed except by written
                            agreement signed by both the student and the School Official. I also understand that if I
                            default on this agreement, I will be responsible for paying any collection fees or attorney
                            fees assessed by Bay Atlantic University (BAU). By clicking the box below, I hereby affix
                            my electronic signature, indicating my intent to be legally bound by the terms of this
                            Enrollment Agreement and the Student Handbook. My signature below signifies that I have read,
                            understood, and acknowledged all aspects of this agreement, and I have recognized my legal
                            responsibilities under this contract.
                        </p>
                    </div>
                    <div class="mt-4">
                        <div><strong>Student Full Name: </strong>{{ studentData.name + ' ' + (studentData.middle_name ? studentData.middle_name + ' ' : '') + studentData.surname }}</div>
                        <div class="mt-2"><strong>Date: </strong>{{ currentDate }}</div>
                    </div>
                </b-col>
                <b-col cols="12" class="mt-4">
                    <ValidationProvider name="accept" rules="required" v-slot="{ errors }">
                        <div class="d-flex align-items-center">
                            <b-form-checkbox
                                id="checkbox-ce-sign"
                                v-model="form.accept"
                                name="checkbox-ce-sign"
                                value="accepted"
                                :unchecked-value="null"
                                class="mr-2"
                            >
                            </b-form-checkbox>
                            <span class="font-weight-bold">
                                [CLICK TO SIGN] I ACCEPT THE TERMS OF THIS AGREEMENT
                            </span>
                        </div>
                        <b-form-invalid-feedback v-if="errors[0]" class="d-block">
                            {{ errors[0] }}
                        </b-form-invalid-feedback>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" class="mt-3">
                    <b-row class="d-flex align-items-center justify-content-center">
                        <b-col cols="12" md="4" class="text-md-end mt-3 mt-md-0">
                            <b-button
                                type="submit"
                                @click="next"
                                variant="primary"
                                class="w-100 w-md-auto px-3 px-md-4 py-2"
                            >
                                {{ $t('sign').toUpperCase() }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>
<script>
import {mapGetters} from "vuex";
import moment from "moment";

export default {
    data() {
        return {
            form: {},
        }
    },
    created() {
        window.scrollTo(0, 0)
    },
    computed: {
        ...mapGetters({
            studentData: "enrollmentAgreementForm/formData"
        }),
        currentDate() {
            return moment().format("MMMM Do YYYY")
        }
    },
    methods: {
        async next() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                this.$emit('next', 1)
            }
        },
        back() {
            this.$emit('back', -1);
        }
    }
}
</script>
